
import { apiJson } from '../lib/api';

export interface PlaidCategory {
  group: string;
  hierarchy: string[];
  category_id: string;
}

export interface CategoriesResponse {
  categories: PlaidCategory[];
  error?: string;
}

export interface RefreshCategoriesResponse {
  success: boolean;
  categoryCount?: number;
  error?: string;
}

const API_PATH = '/api/categories';

/**
 * Service to handle Plaid Category operations
 */
export const CategoryService = {
  /**
   * Fetch all Plaid categories (Taxonomy)
   * Requires authentication token
   * @param token - Authorization token
   */
  async getAllCategories(token: string): Promise<PlaidCategory[]> {
    try {
      const data = await apiJson<CategoriesResponse>(API_PATH, undefined, token);
      if (data.error) {
        console.error('Error fetching categories:', data.error);
        throw new Error(data.error);
      }
      return data.categories || [];
    } catch (error) {
      console.error('CategoryService.getAllCategories error:', error);
      throw error;
    }
  },

  /**
   * Force refresh categories from Plaid API
   * Fetches fresh data from Plaid and updates the database cache
   * @param token - Authorization token
   */
  async refreshCategories(token: string): Promise<RefreshCategoriesResponse> {
    try {
      const data = await apiJson<RefreshCategoriesResponse>(
        `${API_PATH}/refresh`,
        { method: 'POST' },
        token
      );
      return data;
    } catch (error) {
      console.error('CategoryService.refreshCategories error:', error);
      throw error;
    }
  },
};
